import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createCartoonTypeItem,
  getAllCartoonTypeItems,
  getDataForEdit,
  updateCartoonTypeItem,
  deleteCartoonTypeItem,
} from "../../store/CartoonType/CartoonTypeApi";
import { getProductItems } from "../../store/AppLevelApi/AppLevelApi";
import { cartoonTypeSliceAction } from "../../store/CartoonType/CartoonTypeSlice";
import { headTitle } from "../../utility/GetTableListName";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsCartoonType } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialCartoonTypeFormData } from "../../ConstantData/InitialData";
import { ErrorCartoonTypeFormData } from "../../ConstantData/ErrorOption";
function CartoonType() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllCartoonTypeItems()); //initial list data
    // dispatch(getProductItems("product"));
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const cartoonTypeList = useSelector(
    (state) => state.cartoontype.cartoonTypeList
  ); //store user list

  const InitialFormDataStore = useSelector(
    (state) => state.cartoontype.initialData
  );
  const cartoonTypeEditData = useSelector(
    (state) => state.cartoontype.dataEdit
  );
  const productList = useSelector((state) => state.applevel.productList);
  let cartoonTypeFormError = useSelector(
    (state) => state.cartoontype.errorData
  );
  let isError = useSelector((state) => state.cartoontype.isError);
  cartoonTypeFormError = {
    ...ErrorCartoonTypeFormData,
    ...cartoonTypeFormError,
  };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsCartoonType));
  if (productList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsCartoonType.map((item) => {
      if (item?.labelName === "Product") {
        item.options = productList;
      }
      return item;
    });
  }

  const headTitleLabel = headTitle(FormOptionsCartoonType, [
    "Name",
    "Size",
    "Product",
    "Product Quantity",
  ]); //array is field that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialCartoonTypeFormData}
      createFun={createCartoonTypeItem} //create function coming from store
      updateFun={updateCartoonTypeItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteCartoonTypeItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create Cartoon Type"
      OptionNameList="Cartoon Type"
      generalList={cartoonTypeList}
      headTitle={headTitleLabel}
      EditData={cartoonTypeEditData}
      generalModuleList={productList} //list to add different module
      ErrorData={cartoonTypeFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={cartoonTypeSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default CartoonType;
